var _excluded = ["startDatePlaceholderText", "endDatePlaceholderText", "openDirection", "displayFormat", "labels", "disabled", "displayTime", "rootContainerSx"],
    _excluded2 = ["labels", "displayTime", "rootContainerSx"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable max-len */
import 'react-dates/initialize';
import { chakra } from '@chakra-ui/system';
import React from 'react';
import { DateRangePicker } from 'react-dates';
import { DtrpContextProvider, useDrtpContext } from './hooks';
import { TimeType } from './hooks/types';
import { useDTRPdom } from './hooks/useDTRPdom';
import * as Icons from './icons';
import * as Styles from './styles/styles';
import { DRTPTimePicker } from './time-picker';
/** TODOS
 * [sort-of] Responsiveness (Im thinking for mobile - put time picker below date picker)
 *    [] Label placements breaking on mobile?
 *    [] Display DT values within picker Header?
 * [] Tests (kraken + tidal)
 * [] Documentation
 */

/** Questions ~ Concerns
 * - Clear/Reset button?
 * - Labels? (pickup/dropoff)
 * - placement of the time picker (responsiveness)
 */

/**
 * Bugs
 * [] - selecting dropoffDate that engulfs a res time should reset pickup date
 */

export var DateTimeRangePicker = _ref => {
  var {
    startDatePlaceholderText,
    endDatePlaceholderText,
    openDirection,
    displayFormat,
    labels,
    disabled,
    displayTime,
    rootContainerSx
  } = _ref,
      hookProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(DtrpContextProvider, hookProps, /*#__PURE__*/React.createElement(DateTimeRangePickerDisplay, {
    disabled: disabled,
    displayFormat: displayFormat,
    displayTime: displayTime,
    endDatePlaceholderText: endDatePlaceholderText,
    labels: labels,
    openDirection: openDirection,
    rootContainerSx: rootContainerSx,
    startDatePlaceholderText: startDatePlaceholderText
  }));
};
export var DateTimeRangePickerDisplay = _ref2 => {
  var {
    labels,
    displayTime,
    rootContainerSx
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var {
    state,
    methods
  } = useDrtpContext();
  var drtpDom = useDTRPdom({
    state,
    methods,
    labels,
    disabled: props.disabled
  });

  var wrapperStyles = _extends({
    '.DateInput:nth-of-type(1)::before': {
      content: "'" + labels.start + "'",
      color: 'gray.900'
    },
    '.DateInput::before': {
      content: "'" + labels.end + "'",
      fontSize: 'sm',
      color: 'gray.900'
    },
    '.DateInput::after': {
      background: 'url("data:image/svg+xml,%3Csvg width=\'12\' height=\'24\' viewBox=\'0 0 12 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6.70711 14.2929C6.31658 14.6834 5.68342 14.6834 5.29289 14.2929L1.70711 10.7071C1.07714 10.0771 1.52331 9 2.41421 9H9.58579C10.4767 9 10.9229 10.0771 10.2929 10.7071L6.70711 14.2929Z\' fill=\'%23FFAC06\'/%3E%3C/svg%3E%0A") center / contain no-repeat',
      display: 'block',
      width: 5,
      height: 5,
      content: '""',
      bottom: 3,
      right: 0,
      position: 'absolute'
    }
  }, rootContainerSx && {
    '.DateRangePickerInput': rootContainerSx
  });

  return /*#__PURE__*/React.createElement(chakra.div, {
    __css: wrapperStyles,
    "aria-label": "date-time-range-picker-wrapper",
    ref: drtpDom.state.containerRef
  }, /*#__PURE__*/React.createElement(DateRangePicker, _extends({
    calendarInfoPosition: drtpDom.state.isDesktop ? 'after' : 'bottom',
    customArrowIcon: /*#__PURE__*/React.createElement(Styles.DividerIcon, null),
    customCloseIcon: /*#__PURE__*/React.createElement(Icons.CloseIcon, {
      "data-test-id": "drtp-close-button"
    }),
    dayPickerNavigationInlineStyles: Styles.baseStyle.inlineNavigation,
    daySize: 50,
    endDate: state.endDate,
    endDateAriaLabel: "end-date-input",
    endDateId: TimeType.END,
    focusedInput: state.focusedInput,
    hideKeyboardShortcutsPanel: true,
    horizontalMonthPadding: 0,
    isOutsideRange: state.focusedInput === 'startDate' ? methods.isOutsideStartRange : methods.isOutsideEndRange,
    keepFocusOnInput: true,
    keepOpenOnDateSelect: true,
    minimumNights: 0,
    navNext: /*#__PURE__*/React.createElement(Styles.CaretAddon, {
      "data-test-id": "drtp-prev-month-arrow"
    }, /*#__PURE__*/React.createElement(Icons.CaretRightIcon, {
      color: "brand.500"
    })),
    navPrev: /*#__PURE__*/React.createElement(Styles.CaretAddon, {
      "data-test-id": "drtp-next-month-arrow"
    }, /*#__PURE__*/React.createElement(Icons.CaretLeftIcon, {
      color: "brand.500"
    })),
    noBorder: true,
    numberOfMonths: 1,
    onClose: () => methods.setFocusedInput(null),
    onDatesChange: methods.onDatesChange,
    onFocusChange: () => null,
    readOnly: true,
    renderCalendarInfo: () => {
      if (!displayTime) return null;
      var startIsFocused = state.focusedInput === 'startDate';
      var endIsFocused = state.focusedInput === 'endDate';
      var value = state[startIsFocused ? 'startTime' : 'endTime'];
      var unavailableTimes = startIsFocused ? state.unavailableStartTimes : state.unavailableEndTimes;
      return /*#__PURE__*/React.createElement(Styles.CalendarInfo, {
        sx: _extends({}, drtpDom.state.isDesktop && {
          borderLeft: '1px',
          borderColor: 'gray.200'
        }, !drtpDom.state.isDesktop && {
          borderTop: '1px',
          borderColor: 'gray.200'
        }, startIsFocused && !state.startDate && {
          opacity: 0.5,
          pointerEvents: 'none'
        }, endIsFocused && !state.endDate && {
          opacity: 0.5,
          pointerEvents: 'none'
        })
      }, /*#__PURE__*/React.createElement(DRTPTimePicker, {
        onSelect: methods.onTimesChange,
        unavailableTimes: unavailableTimes,
        value: value
      }));
    },
    renderDayContents: day => /*#__PURE__*/React.createElement(Styles.DateContainer, {
      "data-test-id": "dtrp-day-" + day.format('MM/DD/YY hh:mm A'),
      key: day.format('MM/DD/YY hh:mm A')
    }, day.format('D')),
    startDate: state.startDate,
    startDateId: TimeType.START,
    verticalHeight: 307,
    withFullScreenPortal: !drtpDom.state.isDesktop
  }, props)));
};
DateTimeRangePickerDisplay.defaultProps = {
  displayFormat: 'M/D/YY [-] hh:mm a',
  startDatePlaceholderText: 'Pick Up',
  endDatePlaceholderText: 'Drop Off',
  openDirection: 'down',
  disabled: undefined,
  displayTime: true,
  labels: {
    end: 'End Date',
    start: 'Start Date'
  }
};
//# sourceMappingURL=date-time-range-picker.js.map